import FileUpdate from './FileUpdate'
export {FileUpdate}
export default FileUpdate
